import { render, staticRenderFns } from "./wisdomCity.vue?vue&type=template&id=299d63a2&scoped=true"
import script from "./wisdomCity.vue?vue&type=script&lang=js"
export * from "./wisdomCity.vue?vue&type=script&lang=js"
import style0 from "./wisdomCity.vue?vue&type=style&index=0&id=299d63a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299d63a2",
  null
  
)

export default component.exports